<section class="animated fadeIn">
    <div class="breadcrumbArea">
        <div class="container">
            <div class="row justify-content-between align-items-center">
                <div class="col">
                    <nav>
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a routerLink="/approval">DASHBOARD</a></li>
                            <li class="breadcrumb-item active">Configure role for delegation</li>
                        </ol>
                    </nav>
                </div>
            </div>
        </div>
    </div>

    <div class="mt20"> 
        <div class="container">
            <div class="whiteBox"> 
                <div class="row">
                    <div class="col-md-4 cstmDD">
                        <label>Application</label>
                        <p-dropdown [options]="option1"></p-dropdown>
                    </div>
                    <div class="col-md-4 cstmDD">
                        <label>Role Type</label>
                        <p-dropdown [options]="option1"></p-dropdown>
                    </div>
                    <div class="col-md-4 cstmDD">
                        <label>Role Name</label>
                        <input type="text" placeholder="Type Here" pInputText>
                    </div>
                    <div class="col-md-12 cstmDD mt15">
                        <label>Remarks</label>
                        <textarea placeholder="Type Here" rows="2" pInputTextarea></textarea>
                    </div>
                </div>
            </div>
            <div class="glb-btn mb20">
                <button class="secondry-border mr-3">CANCEL</button>
                <button (click)="alert(alertTemp)" class="primary-button">SUBMIT</button>
            </div>
        </div>
    </div>
</section>

<!-- alertTemp -->
<ng-template #alertTemp>
    <div class="mtable">
        <div class="mCell">
            <h4 (click)="modalRef.hide()" class="closeS"><i class="icon-cancel"></i></h4>
            <span class="alertIcon"> <img [src]="alertIcon" /> </span>
            <h3>Are you sure you want to submit request?</h3>
            <div class="glb-btn">
                <button (click)="modalRef.hide()" class="secondry-border mr-3">CANCEL</button>
                <button (click)="modalRef.hide(); showSuccess()" class="primary-button">OK</button>
            </div>
        </div>
    </div>
</ng-template>


<!-- successMessage -->
<p-toast styleClass="successM" position="top-center" [modal]="true" [baseZIndex]="5000">
    <ng-template let-message pTemplate="message">
        <div class="mtable">
            <div class="mCell sucImg ">
                <img src="assets/images/tick.gif" alt="">
                <h3>Request has been submitted successfully.</h3>
            </div>
        </div>
    </ng-template>
</p-toast>
